import * as React from "react";
import { useHistory } from "react-router-dom";

import { titles } from "../../../constants/titles";
import {
  registrationNumChangeRequestPath,
  schoolDocumentsPath,
} from "../../../managerStore";
import { Breadcrumb } from "../../../molecules/Breadcrumb";
import { ReactComponent as ArrowIcon } from "../../../assets/images/Home/icon_arrow_link.svg";

import styles from "./ContractManagement.module.scss";

const menuItems = [
  {
    label: titles.registrationNumChangeRequest,
    desc: "学年ごとのアカウント数の変更を申請できます",
    path: registrationNumChangeRequestPath,
  },
  {
    label: titles.schoolDocuments,
    desc: "発行された請求書・納品書・領収書の確認・ダウンロードができます",
    path: schoolDocumentsPath,
  },
];

export default () => {
  const history = useHistory();

  return (
    <div>
      <Breadcrumb currentTitle={titles.contractManagement} />
      <div className={styles.container}>
        <div className={styles.title}>
          <p>{titles.contractManagement}</p>
          <span>ご契約に関する申請・確認ができます。</span>
        </div>
        <div className={styles.menu}>
          {menuItems.map(item => (
            <button
              key={item.path}
              className={styles.box}
              type="button"
              onClick={() => history.push(item.path)}
            >
              <p className={styles.label}>{item.label}</p>
              <div className={styles.group}>
                <p className={styles.desc}>{item.desc}</p>
                <ArrowIcon className={styles.icon} />
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
